import { initConfetti } from 'js/lib/confetti.js'
import { registerFunctionalComponent } from 'js/lib/components/component'

registerFunctionalComponent(
  '.js-c-confetti',
  'ConfettiComponent',
  ConfettiComponent
)

function ConfettiComponent(component) {
  const el = component.element
  const duration = parseInt(el.dataset.duration, 10) || 2000
  const triggerType = el.dataset.triggerType || 'manual'
  const delay = parseInt(el.dataset.delay, 10) || 0
  const variant = el.dataset.variant || 'full'

  const fireConfetti = () => {
    initConfetti(duration, variant, el)
    el.dataset.trigger = 'false'
  }

  switch (triggerType) {
    case 'onload':
      window.addEventListener('DOMContentLoaded', () => fireConfetti())
      break

    case 'delay':
      setTimeout(fireConfetti, delay)
      break

    case 'inview':
      // eslint-disable-next-line no-undef
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            fireConfetti()
            observer.disconnect()
          }
        })
      })
      observer.observe(el)
      break

    case 'manual':
    default:
      // eslint-disable-next-line no-undef
      const observerManual = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'data-trigger' &&
            el.dataset.trigger === 'true'
          ) {
            fireConfetti()
          }
        }
      })
      observerManual.observe(el, { attributes: true })
      break
  }
}
